import { Role } from '../contexts/Authentication';

const canPublish = (roles: Role[]) => {
    return [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior].some(r => roles.includes(r));
};

export {
    canPublish,
}
  